'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stageInitialMessage = stageInitialMessage;

var _buildSender = require('conversations-schema/common-message-format-conversion/operators/buildSender');

var _cmfSenderTypes = require('conversations-schema/common-message-format/constants/cmfSenderTypes');

var _statusTypes = require('conversations-schema/common-message-format/constants/statusTypes');

var _MessageDescriptorSources = require('conversations-schema/constants/MessageDescriptorSources');

var _ThreadSources = require('conversations-schema/constants/ThreadSources');

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _buildInitialMessage = require('conversations-schema/initial-message/operators/buildInitialMessage');

var _messageTypes = require('conversations-schema/pubnub-message/constants/messageTypes');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _isUngatedForInitialMessage = require('../../gates/selectors/isUngatedForInitialMessage');

var _buildUrlContextUpdateMessage = require('../../pubnub-message/factories/buildUrlContextUpdateMessage');

var _getInitialResponder = require('../../responders/selectors/getInitialResponder');

var _getSelectedThreadId = require('../../selected-thread/selectors/getSelectedThreadId');

var _getIsBot = require('../../selectors/widgetDataSelectors/getIsBot');

var _getMessagesPageUri = require('../../selectors/widgetDataSelectors/getMessagesPageUri');

var _stageMessageOnStubbedThread = require('../../stubbed-thread-history/actions/stageMessageOnStubbedThread');

var _getFirstMessageText = require('../../thread-histories/selectors/getFirstMessageText');

var _stageSupplementalInitialMessages = require('./stageSupplementalInitialMessages');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function stageInitialMessage() {
  return function (dispatch, getState) {
    var state = getState();

    var isBot = (0, _getIsBot.getIsBot)(state);
    var responderToUse = (0, _getInitialResponder.getInitialResponder)(state);
    var currentUrl = (0, _getMessagesPageUri.getMessagesPageUri)(state);
    var senderId = (0, _responderGetters.getUserId)(responderToUse);

    if ((0, _isUngatedForInitialMessage.isUngatedForInitialMessage)(state)) {
      var unpublishedInitialMessage = (0, _buildInitialMessage.buildInitialMessage)({
        sender: (0, _buildSender.buildSender)({
          senderType: isBot ? _cmfSenderTypes.BOT_SENDER : _cmfSenderTypes.AGENT_SENDER,
          senderId: senderId
        }),
        status: {
          messageStatus: _statusTypes.SENT,
          source: _ThreadSources.LIVE_CHAT
        },
        text: (0, _getFirstMessageText.getFirstMessageText)(state)
      });
      dispatch((0, _stageMessageOnStubbedThread.stageMessageOnStubbedThread)(unpublishedInitialMessage));
    } else {
      var _metadata;

      var threadId = (0, _getSelectedThreadId.getSelectedThreadId)(state);
      var _unpublishedInitialMessage = (0, _buildUnpublishedMessage.buildUnpublishedMessage)({
        metadata: (_metadata = {}, _defineProperty(_metadata, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.INITIAL_MESSAGE), _defineProperty(_metadata, 'text', (0, _getFirstMessageText.getFirstMessageText)(getState())), _metadata),
        descriptor: { source: _MessageDescriptorSources.THIS_CLIENT },
        senderType: isBot ? _senderTypes.BOT : _senderTypes.AGENT,
        senderId: senderId,
        threadId: threadId
      });

      dispatch((0, _stageMessageOnStubbedThread.stageMessageOnStubbedThread)(_unpublishedInitialMessage));
    }

    if (isBot) {
      dispatch((0, _stageSupplementalInitialMessages.stageSupplementalInitialMessages)()).then(function () {
        dispatch((0, _stageMessageOnStubbedThread.stageMessageOnStubbedThread)((0, _buildUrlContextUpdateMessage.buildUrlContextUpdateMessage)(currentUrl)));
      }).done();

      return;
    }

    dispatch((0, _stageMessageOnStubbedThread.stageMessageOnStubbedThread)((0, _buildUrlContextUpdateMessage.buildUrlContextUpdateMessage)(currentUrl)));
  };
}